// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__14ySg","col":"styles_col__3ZoP1","fulfillmentStatus":"styles_fulfillmentStatus__398mS","emailCol":"styles_emailCol__3aFir"};